import { Flex } from '@zillow/constellation';
import styled from 'styled-components';

export const TourAvailabilityCalendarFooterContainer = styled(Flex)`
  width: 100%;
`;
